import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  EffectNotification,
  ofType,
  OnRunEffects
} from "@ngrx/effects";
import { YoumAPIFacade } from "@youm-front/core";
import { Observable } from "rxjs";
import { exhaustMap, map, takeUntil } from "rxjs/operators";
import { RoomActions } from "../actions";

@Injectable()
export class RoomRemoteStreamsEffects implements OnRunEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly youmAPIFacade: YoumAPIFacade
  ) {}

  disposeRoomRemoteData$ = createEffect(() =>
    this.youmAPIFacade.disconnect$.pipe(
      map(() => RoomActions.disposeRoomRemoteData())
    )
  );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(RoomActions.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(this.actions$.pipe(ofType(RoomActions.destroy)))
        )
      )
    );
  }
}
